<template>
    <div>
        <hts-modal
            :show="cVisible"
            :size="90"
            :click-outside-close="false"
            @hide="() => (cVisible = false)">
            <hts-data-table
                ref="dataTables"
                v-loading="loading"
                :headers="headers"
                :items="items"
                :is-cell-clicked="false"
                :pagination="true"
                :is-footer="true" />
        </hts-modal>
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  loading: Boolean,
  items: Array<any>,
  headers: Array<any>,
  visible: Boolean
})

const { visible } = toRefs(props)
const emits = defineEmits(['update:visible'])

const cVisible = computed({
  get () {
    return visible.value
  },
  set (val) {
    emits('update:visible', val)
  }
})

defineExpose({})
</script>
